<template>
  <q-dialog ref="dialogRef" v-on="dialogListeners" v-bind="dialogProps">
    <q-card ref="cardRef" class="full-width">
      <q-form @submit.prevent="onSubmit" @validation-error="onValidationError">
        <dialog-header @close="onCloseDialog" title="Sua opinião é importante para nós!" sticky />
        <dialog-body>
          <nps-response-content v-model="innerNpsResponse" />
        </dialog-body>
        <q-separator/>
        <q-card-actions align="right">
          <q-space />
          <q-btn
            @click="onCloseDialog"
            label="Fechar"
            color="accent"
            padding="sm md"
            flat
          />
          <q-btn
            type="submit"
            label="Salvar"
            :disable="submitLoading"
            color="primary"
            text-color="dark"
            padding="sm md"
          >
            <q-inner-loading :showing="submitLoading"/>
          </q-btn>
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import { defineComponent, defineProps, defineEmits, ref, shallowReactive } from 'vue'
import { useDialogPluginComponent, useQuasar } from 'quasar'
import { api } from 'src/boot/axios'
import cloneDeep from 'lodash.clonedeep'

import { useDialog } from 'src/composables/dialog'
import { useDialogFormScroll } from 'src/composables/formScroll'
import { DEFAULT_NPS_RESPONSE } from 'src/constants/nps'
import NpsResponseContent from 'src/components/nps/NpsResponseContent.vue'

export default defineComponent({
  name: 'NpsResponseDialog'
})
</script>

<script setup>

const props = defineProps({
  npsId: [Number, String]
})

/* const emit = */ defineEmits([...useDialogPluginComponent.emits])

const $q = useQuasar()

const { dialogRef, onDialogHide, onDialogOK: onOKClick, onDialogCancel: onCancelClick } = useDialogPluginComponent()

const { dialogProps, dialogListeners, onCloseDialog } = shallowReactive(useDialog(
  { onDialogHide, onCancelClick, onOKClick },
  async ({ confirmExit, isEqual }) => {
    if (submitLoading.value) return
    if (!isEqual(initialNpsResponse, innerNpsResponse.value) &&
      await confirmExit({
        title: 'Resposta não enviada',
        message: 'Sua resposta ainda não foi enviada, deseja sair mesmo assim?',
        okLabel: 'Continuar Respondendo'
      }) === false) return
    onCancelClick()
  }
))

const cardRef = ref(null)
const { onValidationError } = useDialogFormScroll(dialogRef, cardRef)

const innerNpsResponse = ref(cloneDeep(DEFAULT_NPS_RESPONSE))
const initialNpsResponse = cloneDeep(innerNpsResponse.value)

const submitLoading = ref(false)
const onSubmit = async () => {
  try {
    submitLoading.value = true
    const payload = cloneDeep(innerNpsResponse.value)

    await api.post(`nps/${props.npsId}/answer`, payload, {
      customErrorHandlers: {
        403: () => {
          $q.notify({
            message: 'Sua resposta à essa pesquisa já foi enviada.',
            type: 'alert'
          })
        },
        422: () => {
          $q.notify({
            message: 'Nenhuma pontuação foi selecionada.',
            type: 'alert'
          })
        }
      }
    })

    $q.notify({
      message: 'Resposta enviada com sucesso.',
      type: 'positive'
    })

    onOKClick()
  } finally {
    submitLoading.value = false
  }
}

</script>
